<template>
  <div class="container"></div>
</template>

<script>
export default {
  name: "infoView"
}
</script>

<style scoped>

</style>